<template>
  <div id="pulseError">
    <el-card
      :style="{width: dialogWidth}"
      shadow="hover"
    >
      <el-row
        type="flex"
        :gutter="2"
      >
        <el-col
          :span="responsiveCol.one"
          class="colLogo"
        >
          <i
            v-if="errorData.code === 406 || errorData.key === 'cvcAlreadySubmitted'"
            class="icon el-icon-circle-check"
          ></i>
          <i
            v-else
            class="icon el-icon-warning-outline"
          ></i>
        </el-col>
        <el-col
          :span="responsiveCol.two"
          class="colContent"
        >
          <div
            v-if="errorData.key === 'cvcNotOpen'"
            class="content"
          >
            CVC submission is currently not open.
            <br />
            For questions, please contact us at
            <a href="mailto:Help@GlobalCoachGroup.com">
              Help@GlobalCoachGroup.com
            </a>
          </div>
          <div
            v-else
            class="content"
          >
            {{ errorData.text }}
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    errorData: {
      type: Object,
      default: null,
    },
    dialogWidth: {
      type: String,
      default: '50%',
    },
    leader: {
      type: Object,
      default: null,
    },
  },

  computed: {
    responsiveCol() {
      const col = {};
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col.one = 24;
        col.two = 24;
      } else {
        col.one = 4;
        col.two = 20;
      }
      return col;
    },
  },
};
</script>

<style lang="scss" scoped>
#pulseError {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .el-row {
    flex-wrap: wrap;

    .el-col {
      justify-content: center;
      align-self: center;

      &.colLogo {
        text-align: center;
        padding: 20px 0;
      }

      &.colContent {
        padding: 15px;
      }
    }
  }

  .el-card {
    width: 35%;
    margin: 0 auto;
    text-align: left;
    background-color: rgba(255, 255, 255, 0.9);

    .icon {
      font-size: 70px;

      &.el-icon-warning-outline {
        color: #d6a552;
      }

      &.el-icon-circle-check {
        color: #00ace2;
      }
    }
  }
}
</style>
